import React from 'react';
import { GridColumn, GridRow } from 'app/layouts/grid';
import { Button } from 'app/shared/button';
import { OptionCard } from './OptionCard';
import styles from '../organization.module.css';

export const QuestionScreen = ({
  title,
  subtext,
  options,
  value,
  onSelect,
  onBack,
  onContinue,
  continueLabel = 'Continue →'
}) => (
  <>
    <div className={styles.questionTitle}>{title}</div>
    <p className={styles.questionSubtext}>{subtext}</p>
    <div className={styles.optionsGrid}>
      {options.map((opt) => (
        <OptionCard
          key={opt.value}
          label={opt.label}
          description={opt.description}
          selected={value === opt.value}
          onClick={() => onSelect(opt.value)}
        />
      ))}
    </div>
    <div className={styles.actionRow}>
      <GridRow num_of_columns={2}>
        <GridColumn>
          <Button type="secondary" className={styles.btnSecondary} text="← Back" onClick={onBack} />
        </GridColumn>
        <GridColumn>
          <Button
            className={styles.btnPrimary}
            text={continueLabel}
            onClick={onContinue}
            disabled={!value}
          />
        </GridColumn>
      </GridRow>
    </div>
  </>
);
